import React from 'react';
import { Plus } from 'lucide-react';

/**
 * Zero-match state: create-topic CTA prefilled with the query, link back to default list.
 */
const ConnectionsZeroMatch = ({
  query,
  onCreateTopic,
  onBackToList,
}) => {
  const trimmed = query?.trim() ?? '';

  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center p-8 gap-4">
      <p className="text-neutral-600 text-sm sm:text-base max-w-sm">
        No matches for &ldquo;{trimmed}&rdquo;.
      </p>
      <button
        type="button"
        onClick={onCreateTopic}
        className="inline-flex items-center gap-2 px-4 py-2.5 bg-cranberry-700 text-white rounded-xl border-2 border-neutral-900 font-medium hover:bg-cranberry-600 transition-colors text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-cranberry-800"
        aria-label={`Create topic named ${trimmed}`}
      >
        <Plus size={18} aria-hidden="true" />
        Create topic &ldquo;{trimmed}&rdquo;
      </button>
      <button
        type="button"
        onClick={onBackToList}
        className="text-sm text-neutral-600 underline hover:text-neutral-900 focus:outline-none focus:ring-2 focus:ring-cranberry-700 rounded"
      >
        Back to basket list
      </button>
    </div>
  );
};

export default ConnectionsZeroMatch;
